import(/* webpackMode: "eager" */ "/var/www/Fixr/frontend/app/pricing/page.tsx");
